import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as GC from '@grapecity/spread-sheets';
import { MenuService } from '@services/menu.service';
import { isAlt, isAltLeftArrow, isCtrl, isEscape, isShift } from '@shared/key-codes';
import { hostStyle, spreadBackColor } from '@shared/spread/spread-settings';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs/operators';
import { notificationWorkbookInit, populateNotificationSpread, setUpNotificationWorkbook } from './notification-spread';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit, AfterViewInit {
  private sheet: GC.Spread.Sheets.Worksheet = null;
  private spread: GC.Spread.Sheets.Workbook = null;

  public notificationsOpen = false;
  public readonly destroyed$ = new Subject();
  public readonly hostStyle = hostStyle;
  public readonly spreadBackColor = spreadBackColor;

  get notifications() {
    return this.data.notifications;
  }

  /**
   * Kendo Window dimensions (Notifications)
   */
  public dim = {
    left: () => Math.min((window.innerWidth - this.dim.minWidth()) / 2, 140),
    top: () => Math.min((window.innerHeight - this.dim.minHeight()) / 2, 140),
    width: () => window.innerWidth - this.dim.left() * 2,
    height: () => window.innerHeight - this.dim.top() * 2,
    minWidth: () => Math.min(860, window.innerWidth),
    minHeight: () => Math.min(540, window.innerHeight)
  };

  constructor(
    public dialogRef: MatDialogRef<NotificationComponent>,
    private readonly menuService: MenuService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.notificationsOpen = true;
  }

  ngAfterViewInit(): void {
    this.initKeyboardEventsListener();
  }

  public initNotificationSpread(args): void {
    this.spread = notificationWorkbookInit(args);
    this.sheet = this.spread.getActiveSheet();
    setUpNotificationWorkbook(this.spread, this.sheet);
    this.onWindowResize();
    populateNotificationSpread(this.spread, this.sheet, this.notifications);
  }

  private initKeyboardEventsListener() {
    this.dialogRef
      .keydownEvents()
      .pipe(
        takeUntil(this.destroyed$),
        distinctUntilChanged(),
        // ignore alt, shiftKey, ctrl key presses as is the first key for a command combination
        filter(ke => !(isCtrl(ke) || isAlt(ke) || isShift(ke)))
      )
      .subscribe((ke: KeyboardEvent) => {
        if (isEscape(ke)) {
          // Prevent closing dialog if Escape key was pressed on any Spread dropdown
          // tslint:disable-next-line
          const path = event['path'].map(x => x.tagName);
          if (!(path.includes('GC-SPREAD-SHEETS') && path.includes('SELECT'))) {
            this.closeModal();
          }
          // Prevent closing dialog when pressing Alt+Left - Bug 3201
        } else if (isAltLeftArrow(ke)) {
          // tslint:disable-next-line
          event.preventDefault();
        }
      });
  }

  public closeModal() {
    this.dialogRef.disableClose = false;
    this.dialogRef.close();
  }

  public onWindowResize() {
    this.menuService.emitResize();
  }
}
